module.exports = __webpack_public_path__ + "static/img/taiqiudashi.9bd738c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/taiqiudashi.jpg
// module id = YXis
// module chunks = 0